export default {
  ALTERATIONS_COUNT_LOADING: '@ALTERATIONS_COUNT_LOADING',
  ALTERATIONS_COUNT_SUCCESS: '@ALTERATIONS_COUNT_SUCCESS',
  ALTERATIONS_COUNT_ERROR: '@ALTERATIONS_COUNT_ERROR',

  ALTERATIONS_ITEMS_LOADING: '@ALTERATIONS_ITEMS_LOADING',
  ALTERATIONS_ITEMS_SUCCESS: '@ALTERATIONS_ITEMS_SUCCESS',
  ALTERATIONS_ITEMS_ERROR: '@ALTERATIONS_ITEMS_ERROR',
  ALTERATIONS_ITEMS_CLEAR: '@ALTERATIONS_ITEMS_CLEAR',

  ALTERATIONS_SEARCH_LOADING: '@ALTERATIONS_SEARCH_LOADING',
  ALTERATIONS_SEARCH_SUCCESS: '@ALTERATIONS_SEARCH_SUCCESS',
  ALTERATIONS_SEARCH_ERROR: '@ALTERATIONS_SEARCH_ERROR',
  ALTERATIONS_SEARCH_CLEAR: '@ALTERATIONS_SEARCH_CLEAR',

  ALTERATIONS_ITEM_DETAILS_LOADING: '@ALTERATIONS_ITEM_DETAILS_LOADING',
  ALTERATIONS_ITEM_DETAILS_SUCCESS: '@ALTERATIONS_ITEM_DETAILS_SUCCESS',
  ALTERATIONS_ITEM_DETAILS_ERROR: '@ALTERATIONS_ITEM_DETAILS_ERROR',
  ALTERATIONS_ITEM_DETAILS_CLEAR: '@ALTERATIONS_ITEM_DETAILS_CLEAR',

  MANAGER_ALTERATIONS_ITEMS_LOADING: '@MANAGER_ALTERATIONS_ITEMS_LOADING',
  MANAGER_ALTERATIONS_ITEMS_SUCCESS: '@MANAGER_ALTERATIONS_ITEMS_SUCCESS',
  MANAGER_ALTERATIONS_ITEMS_ERROR: '@MANAGER_ALTERATIONS_ITEMS_ERROR',
  MANAGER_ALTERATIONS_ITEMS_CLEAR: '@MANAGER_ALTERATIONS_ITEMS_CLEAR',

  ALTERATIONS_SELECT_ASSOCIATE_ALTERATIONS: '@SELECT_ASSOCIATE_ALTERATIONS',

  MANAGER_ALTERATIONS_SA_SEARCH: '@MANAGER_ALTERATIONS_SA_SEARCH',
  MANAGER_ALTERATIONS_SA_SEARCH_CLEAR: '@MANAGER_ALTERATIONS_SA_SEARCH_CLEAR',

  MANAGER_ALTERATIONS_ARCHIVE_ITEMS_LOADING: '@MANAGER_ALTERATIONS_ARCHIVE_ITEMS_LOADING',
  MANAGER_ALTERATIONS_ARCHIVE_ITEMS_SUCCESS: '@MANAGER_ALTERATIONS_ARCHIVE_ITEMS_SUCCESS',
  MANAGER_ALTERATIONS_ARCHIVE_ITEMS_ERROR: '@MANAGER_ALTERATIONS_ARCHIVE_ITEMS_ERROR',

  MANAGER_ALTERATIONS_ARCHIVE_ITEMS_CLEAR: '@MANAGER_ALTERATIONS_ARCHIVE_ITEMS_CLEAR',
};
